// Create a company/team for each new user on signup
import { supabase } from './supabaseClient';

export async function createCompanyOnSignup(userId: string, email: string, fullName?: string, companyName?: string) {
  if (!supabase) {
    console.error('❌ Supabase not configured');
    return null;
  }

  console.log('🏢 [TEAM CREATION] Starting for user:', userId);
  console.log('📧 Email:', email);
  console.log('👤 Full Name:', fullName);
  console.log('🏭 Company Name:', companyName);

  try {
    // Use provided company name or generate from user info
    const finalCompanyName = companyName || `${fullName || email.split('@')[0]}'s Company`;
    const teamName = finalCompanyName.replace(/('s Company|Company|Inc\.|LLC|Corp\.)$/i, '').trim();

    console.log('📝 Final company name:', finalCompanyName);
    console.log('📝 Team name:', teamName);

    // Generate a proper UUID for the team (teams.id is TEXT, but profiles.team_id is UUID)
    const teamUuid = crypto.randomUUID();
    console.log('🔨 Creating team in database with UUID:', teamUuid);

    const { data: newTeam, error: teamError } = await supabase
      .from('teams')
      .insert({
        id: teamUuid,  // Explicitly set UUID as text (can be cast to uuid type)
        team_name: teamName,
        name: teamName,
        company_name: finalCompanyName,
        owner_id: userId,  // User is the owner of their company
        status: 'active',
        subscription_tier: 'trial',
        monthly_call_limit: 1000,
        calls_this_month: 0,
        has_payment_method: false,
        phone_system_active: false
      })
      .select()
      .single();

    if (teamError) {
      console.error('❌ Error creating team:', {
        code: teamError.code,
        message: teamError.message,
        details: teamError.details,
        hint: teamError.hint
      });
      throw teamError;
    }

    console.log('✅ Team created:', newTeam.id);

    // Update user profile with their team
    console.log('🔄 Updating profile with team_id...');
    const { error: profileError } = await supabase
      .from('profiles')
      .update({
        team_id: newTeam.id,
        company_name: finalCompanyName
      })
      .eq('id', userId);

    if (profileError) {
      console.error('❌ Error updating profile:', {
        code: profileError.code,
        message: profileError.message,
        details: profileError.details,
        hint: profileError.hint
      });
    } else {
      console.log('✅ Profile updated with team_id');
    }

    // Add user as the owner in team_members
    console.log('👥 Adding user to team_members...');
    const { error: memberError } = await supabase
      .from('team_members')
      .insert({
        team_id: newTeam.id,
        user_id: userId,
        role: 'owner',  // They own their company
        status: 'active'
      });

    if (memberError) {
      console.error('❌ Error creating team member:', {
        code: memberError.code,
        message: memberError.message,
        details: memberError.details,
        hint: memberError.hint
      });
    } else {
      console.log('✅ Team member record created');
    }

    console.log(`✅ Created company "${finalCompanyName}" for ${email}`);
    console.log(`   Team ID: ${newTeam.id}`);
    console.log(`   Owner: ${email}`);

    return newTeam;

  } catch (error: any) {
    console.error('❌ Error in createCompanyOnSignup:', {
      message: error?.message,
      code: error?.code,
      details: error?.details,
      hint: error?.hint,
      stack: error?.stack
    });
    // Don't fail signup if team creation fails
    return null;
  }
}